module.exports = __webpack_public_path__ + "img/smile-icon.0bb76675.svg";